import { useCallback, useState } from "react";
import { useCustomToast } from "components/CustomToast/CustomToast";
import { useTranslation } from "react-i18next";

export function useExportHandler(serviceFn, defaultFileName) {
    const [isLoading, setIsLoading] = useState(false);
    const showToast = useCustomToast();
    const { t } = useTranslation();

    const handler = useCallback(async () => {
        try {
            setIsLoading(true);
            const { data, headers } = await serviceFn();

            const contentDisposition = headers["content-disposition"];
            const fileNameMatch = contentDisposition?.match(/filename="(.+)"/);
            const fileName = fileNameMatch ? fileNameMatch[1] : defaultFileName;

            const url = window.URL.createObjectURL(new Blob([data]));
            Object.assign(document.createElement("a"), {
                href: url,
                download: fileName,
            }).click();

            URL.revokeObjectURL(url);
        } catch (err) {
            showToast({ title: t(err), status: "error" });
        } finally {
            setIsLoading(false);
        }
    }, [serviceFn, defaultFileName, showToast, t]);

    return [handler, isLoading];
}
